import React, { useState } from 'react'
import "./style.css"
import Menu from './menuApi'
import MenuCard from './MenuCard'
import Navbar from './Navbar'
import Name from './Name'



const uniqueList=[
    ...new Set(
        Menu.map((curElem)=>{
            return curElem.category
        })
    ),
    "All"
]
const Restaurant = () => {

    const[menuData , setmenuData] = useState(Menu)
    const[menuList , setmenuList] = useState(uniqueList)
    // console.log(menuData);
    const filterItem=(category)=>{
        if(category === "All"){
            setmenuData(Menu)
            return
        }
        const updatedList = Menu.filter((curElem)=>{
            return curElem.category === category
        })
        setmenuData(updatedList)
    }

  return (
    <>
    <Navbar filterItem={filterItem} menuList={menuList}/>
    <MenuCard menuData={menuData}/>
    </>
  )
}

export default Restaurant
